<template>
  <div class="login" @keyup.enter="Login">
    <div class="signBox">
      <div class="title">培训学习</div>
      <el-form
        class="demo-ruleForm"
        v-bind:model="ruleForm"
        status-icon=""
        v-bind:rules="rules"
        ref="form"
        label-width="0px"
      >
        <el-form-item label="" prop="cellphone">
          <span>用户名</span>
          <el-input
            type="text"
            v-model="ruleForm.cellphone"
            autocomplete="off"
            placeholder="请输入用户名"
            size="smail"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="password">
          <span>密码</span>
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            placeholder="请输入密码"
            size="smail"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="success"
            style="width: 100%; margin-top: 20px"
            @click="Login"
          >
            登录
          </el-button>
        </el-form-item>
        <el-checkbox label="记住用户名" v-model="remember"></el-checkbox>
      </el-form>
    </div>
  </div>
</template>
<script>
import md5 from "md5";
import CryptoJS from 'crypto-js'

export default {
  name: "Login",
  data() {
    const validateCellphone = (rule, value, callback) => {
      if (value) callback();
      else callback(new Error("请输入用户名!"));
    };

    const validatePassword = (rule, value, callback) => {
      if (value) callback();
      else callback(new Error("请输入密码!"));
    };

    let cellphone = "";

    const remember = (() => {
      let remember = localStorage.remember
        ? JSON.parse(localStorage.remember)
        : false;
      if (remember) cellphone = localStorage.cellphone;
      return remember;
    })();

    return {
      remember,
      ruleForm: { cellphone, password: "" },
      rules: {
        cellphone: [{ validator: validateCellphone, trigger: "blur" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
      },
    };
  },
  methods: {
    getFirstMenuKey (menu) {
      if (menu.hasSubMenu) {
        return menu.subMenuList[0].url + '-' + menu.subMenuList[0].menuCode
      } else {
        return menu.url + '-' + menu.menuCode
      }
    },
    Login() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // let password = md5(this.ruleForm.password);
          let password = CryptoJS.SHA256(md5(this.ruleForm.password)).toString()
          let ruleForm = { ...this.ruleForm, password };
          let { data } = await axios.post("/common/account/login", ruleForm);

          console.log('data', data);
          if (data.code !== 200) {
            this.$message.warning(data.message)
            return false;
          }
          if (!data.data.menuList || !data.data.menuList.length) {
            this.$message.error('没有配置菜单权限');
            return false;
          }
          let menuMap = {};
          console.log('data.data.menuList', data.data.menuList)
          _.each(data.data.menuList, (menu)=>{
            menuMap[menu.url] = menu.menuCode;
            if(menu.hasSubMenu){
              _.each(menu.subMenuList, (subMenu=>{
                menuMap[subMenu.url] = subMenu.menuCode;
              }))
            }
          })

          this.$store.commit("setToken", data.data.token);
          this.$store.commit("setAccount", data.data.Account.cellphone);
          this.$store.commit("setAvatar", data.data.Account.imageUrl);
          localStorage.setItem("userName", data.data.Account.name);
          localStorage.setItem("account", data.data.Account.account);
          localStorage.setItem("avatar", data.data.Account.imageUrl);
          const indexMenu = this.getFirstMenuKey(data.data.menuList[0])
          console.log('getFirstMenuKey', indexMenu)
          localStorage.setItem("elearningMenuData", JSON.stringify(data.data.menuList))
          localStorage.setItem("elearningMenuMap", JSON.stringify(menuMap))
          localStorage.cellphone = ruleForm.cellphone;
          localStorage.remember = this.remember;

          let [menuKey, menuCode] = indexMenu.split('-');
          this.$router.push({path: "/pages/" + menuKey, query: { menuCode: menuCode }});
          // this.$store.commit("setMenuHighLight", 'home');
          // this.$store.commit("setMenuTitle", 'index');
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.login
  height: 100vh
  width: 100vw
  background: #EEEEEE
  overflow: hidden
  .signBox
    width: 240px
    padding: 20px
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
</style>



// WEBPACK FOOTER //
// src/components/Login.vue